import { localList, type LocalList } from '@/features/storefront/wishlist/localList';

/**
 * The products this browser opened lately, newest first, for the
 * `recently_viewed` section. Nothing about it reaches the server: it is a
 * convenience for the shopper in front of the screen, not a record of them.
 */
export const RECENTLY_VIEWED_KEY = 'neon_recently_viewed';
export const RECENTLY_VIEWED_MAX = 12;

export function recentlyViewed(sourceKey: string): LocalList {
  return localList(RECENTLY_VIEWED_KEY, sourceKey, RECENTLY_VIEWED_MAX);
}

/** Put a product at the front of the trail (moving it there if it was already on it). */
export function recordProductView(sourceKey: string, productId: string): void {
  const list = recentlyViewed(sourceKey);
  const current = list.get();
  if (current[0] === productId) return;
  list.set([productId, ...current.filter((id) => id !== productId)]);
}

/**
 * The ids a section should show: the trail without the product on screen
 * (it is the one the shopper is looking at), at most `limit`.
 */
export function recentlyViewedIds(
  trail: readonly string[],
  currentProductId: string | null | undefined,
  limit: number,
): string[] {
  return trail.filter((id) => id !== currentProductId).slice(0, limit);
}
